import React, { useEffect, useState } from 'react';
import { Button, Image, Modal } from 'antd';
import fileService from 'common/services/file-service/file.service';
import { UploadFileTypes } from 'common/services/file-service/file.service.types';
import './eiq-document-preview.scss';

interface IEIQDocumentPreviewProps {
  url: string;
  fileType: UploadFileTypes;
  fileName: string;
  contentType?: string;
  buttonText?: string;
}

const EIQDocumentPreview = ({ url, fileType, fileName, contentType, buttonText = 'View' }: IEIQDocumentPreviewProps) => {
  const [objectUrl, setObjectUrl] = useState('');
  const [isImagePreviewVisible, setImagePreviewVisible] = useState(false);
  const [isDocumentModalOpen, setDocumentModalOpen] = useState(false);

  const isImage = contentType?.startsWith('image/');

  useEffect(() => {
    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [objectUrl]);

  const handleView = async () => {
    if (!objectUrl) {
      const file = await fileService.getFile(url, fileType);
      setObjectUrl(URL.createObjectURL(file));
    }

    if (isImage) {
      setImagePreviewVisible(true);
    } else {
      setDocumentModalOpen(true);
    }
  };

  return (
    <>
      <Button size="middle" onClick={handleView}>
        {buttonText}
      </Button>
      {isImage && (
        <Image
          wrapperClassName="eiq-document-preview-hidden-image"
          src={objectUrl}
          alt={fileName}
          preview={{
            visible: isImagePreviewVisible,
            src: objectUrl,
            onVisibleChange: (visible: boolean) => setImagePreviewVisible(visible),
          }}
        />
      )}
      <Modal
        centered
        title={fileName}
        open={isDocumentModalOpen}
        onCancel={() => setDocumentModalOpen(false)}
        footer={null}
        width="80%"
        wrapClassName="eiq-document-preview-modal">
        {objectUrl && <iframe className="eiq-document-preview-frame" src={objectUrl} title={fileName} />}
      </Modal>
    </>
  );
};

export default EIQDocumentPreview;
